import BayModal from '../BayModal';
import BaySpinner from '../BaySpinner';
import './BayModalLoader.scss';

interface BayModalLoaderProps {
	show?: boolean;
	id?: string | number;
	t: (_key: string) => string;
	variant?: string;
	loadingText?: string;
	spinnerSize?: number;
	onHideFunc?: (_value?: boolean) => void;
	backdropClassName?: string;
}

const BayModalLoader = ({
	show = false,
	id,
	t,
	variant = 'modal',
	loadingText = t('loading'),
	spinnerSize = 32,
	onHideFunc = () => {},
	backdropClassName,
}: BayModalLoaderProps) => {
	return (
		variant === 'modal' ? (
			<BayModal
				backdrop="static"
				backdropClassName={backdropClassName}
				bodyClass="py-2 px-3 p-sm-3"
				className="bay-modal bayModalLoaderModal"
				centered
				hideFooter
				hideHeader
				id={id}
				onHideFunc={onHideFunc}
				show={show}
				height={140}
			>
				<div className="bayModalLoaderContent d-flex flex-column align-items-center justify-content-center py-3 text-center">
					<BaySpinner
						hideTitle
						size={spinnerSize}
						borderWidth="4px"
						variant="primary"
					/>
					<div className="bayModalLoaderText mt-3 fw-bold text-dark fs-5">{loadingText}</div>
				</div>
			</BayModal>
		) : (
			<div className="bayModalLoaderContent d-flex flex-column align-items-center justify-content-center py-3 text-center rounded-2">
				<BaySpinner
					hideTitle
					size={spinnerSize}
					borderWidth="4px"
					variant="primary"
				/>
				<div className="bayModalLoaderText mt-3 fw-bold text-dark fs-5">{loadingText}</div>
			</div>
		)
	);
};

export default BayModalLoader;
